import React from "react";
import { MdAdd, MdRefresh } from "react-icons/md";
import Button from "./Button";

interface ListPageShellProps {
  /** Plural noun used in the load-error line, e.g. "programs". */
  entityName: string;
  onRefresh: () => void;
  refreshDisabled?: boolean;
  /** Omit to render no Add button. */
  onAdd?: () => void;
  addLabel?: string;
  error?: string | null;
  /** "searching" when the error came from search mode. */
  errorContext?: "loading" | "searching";
  operationError?: string | null;
  children: React.ReactNode;
}

/**
 * The chrome every list page shares: the Refresh / Add row, the two error
 * boxes, and the table wrapper. Modals go after it in the page.
 */
const ListPageShell: React.FC<ListPageShellProps> = ({
  entityName,
  onRefresh,
  refreshDisabled,
  onAdd,
  addLabel,
  error,
  errorContext = "loading",
  operationError,
  children,
}) => (
  <div>
    <div className="mb-6 mt-6 flex justify-end">
      <div className="flex space-x-3">
        <button
          onClick={onRefresh}
          disabled={refreshDisabled}
          className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 disabled:opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
        >
          <MdRefresh className="mr-2 h-4 w-4" />
          Refresh
        </button>
        {onAdd && (
          <Button onClick={onAdd}>
            <MdAdd className="mr-2 h-4 w-4" />
            {addLabel}
          </Button>
        )}
      </div>
    </div>

    {error && (
      <div className="mb-4 rounded-md border border-red-200 bg-red-50 p-4 dark:border-red-700 dark:bg-red-900">
        <div className="text-red-800 dark:text-red-200">
          Error {errorContext} {entityName}: {error}
        </div>
      </div>
    )}

    {operationError && (
      <div className="mb-4 rounded-md border border-red-200 bg-red-50 p-4 dark:border-red-700 dark:bg-red-900">
        <div className="text-red-800 dark:text-red-200">
          Error: {operationError}
        </div>
      </div>
    )}

    <div className="mt-3">{children}</div>
  </div>
);

export default ListPageShell;
